import { useId } from 'react';

export const GoogleTasksIcon = ({ className }: { className?: string }) => {
  const uid = useId().replace(/:/g, '');
  const maskId = `google-tasks-mask-${uid}`;
  const blurId = `google-tasks-blur-${uid}`;
  const glowId = `google-tasks-glow-${uid}`;

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 192 192"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="152" height="130" x="20" y="52" fill="#bbe2ff" rx="65" />
      <rect width="172" height="152" x="10" y="14" fill="#3186ff" rx="74" />
      <mask
        id={maskId}
        width="172"
        height="152"
        x="10"
        y="14"
        maskUnits="userSpaceOnUse"
      >
        <rect width="172" height="152" x="10" y="14" fill="#fff" rx="74" />
      </mask>
      <g filter={`url(#${blurId})`} mask={`url(#${maskId})`}>
        <rect
          width="152"
          height="130"
          x="20"
          y="52"
          fill={`url(#${glowId})`}
          rx="65"
        />
      </g>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="12"
        d="m61 90 22.172 22.172a4 4 0 0 0 5.656 0L138 63"
      />
      <defs>
        <linearGradient
          id={glowId}
          x1="96"
          x2="100.64"
          y1="166.9"
          y2="67.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".01" stopColor="#a9a8ff" />
          <stop offset=".79" stopColor="#a9a8ff" stopOpacity="0" />
        </linearGradient>
        <filter
          id={blurId}
          width="176"
          height="154"
          x="8"
          y="40"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feGaussianBlur stdDeviation="6" />
        </filter>
      </defs>
    </svg>
  );
};
